import type { FC } from "react";
import { StarRating } from "../StarRating";
import { RegionalReviewCountryFlag } from "./RegionalReviewCountryFlag";
import type { RegionalReviewCardContentProps } from "./types";

export const RegionalReviewCardDesktopContent: FC<
  RegionalReviewCardContentProps
> = ({
  countryCode,
  displayName,
  formattedRating,
  formattedReviewCount,
  rating,
}) => (
  <div className="d-none d-md-flex align-items-center flex-grow-1">
    <div className="flex-grow-1 mr-3 p-3">
      <h3
        className="heading strong mb-1 reviews_regional_card_name"
        style={{ textTransform: "none" }}
      >
        {displayName}
      </h3>
      <div className="d-flex align-items-center">
        <span className="mr-2 font-weight-bold reviews_regional_card_rating_text">
          {formattedRating}
        </span>
        <StarRating rating={rating} size={20} />
        <span className="ml-2 text-gray reviews_regional_card_rating_text_paragraph">
          {formattedReviewCount}
        </span>
      </div>
    </div>
    <RegionalReviewCountryFlag countryCode={countryCode} />
  </div>
);
